export default "__VITE_ASSET__BPK4Ncfo__"